export default "__VITE_ASSET__ByTTNF3a__"